









import { Component, Prop, Vue, Watch, Ref } from 'vue-property-decorator'
import {
  Chart,
  BarElement,
  BarController,
  CategoryScale,
  LinearScale,
  RadarController,
  RadialLinearScale,
  PointElement,
  LineElement,
  Legend,
} from 'chart.js'

import RadarSet from '../models/radar-set';
import { ChartData } from 'chart.js';
import { ChartDataset } from 'chart.js';

@Component
export default class Radar extends Vue {
    @Prop({type: Array})
    private data!: RadarSet[]

    @Ref()
    private canvas!: HTMLCanvasElement

    @Watch('data')
    private async dataChanged() {
        this.loadData()
    }

    private chart!: Chart<'radar', number[], string>

    private async mounted() {
        const ctx = this.canvas.getContext('2d')
        if (ctx) {
        // @ts-ignore
            this.chart = this.getChart(ctx)            
        }        

        this.loadData()
    }    

    private loadData() {
        if(this.chart == null) {
            return
        }
        
        this.chart.data.datasets = []
        this.chart.data.labels = []
        this.data.forEach(element => {
            this.chart.data.labels?.push(element.label)
            this.chart.data.datasets.push({
                label: element.label,
                data: element.values,
                backgroundColor: element.backgroundColor,
                borderColor: element.borderColor,
                pointBackgroundColor: element.pointBackgroundColor,
                pointBorderColor: element.pointBorderColor,
                pointHoverBackgroundColor: element.pointHoverBackgroundColor,
                pointHoverBorderColor: element.pointHoverBorderColor
            })
        });
    }

    private getChart(ctx: CanvasRenderingContext2D, lineBorderWidth = 1 ) {
        return new Chart(ctx, {
      type: 'radar',
      data: {
        labels: [],
        datasets: []
      },
      options: {
        elements: {
          line: {
            borderWidth: lineBorderWidth,
          },
        },
        scales: {
          r: {
            min: 0,
            max: 7,
            grid: {
              color: 'rgb(0, 0, 0, 0.25)',
            },
            pointLabels: {
              color: 'rgb(0, 0, 0)',
              font: { size: 12 },
            },
          },
        },
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              font: { size: 14 },
              boxHeight: 2,
            },
          },
        },
      },
    })
    }
}

